<template>
  <section class="section-container">
    <div class="content-wrapper">
      <div class="content-heading">
        {{ $t('tenderview.tender') }}
      </div>
      <div class="card">
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr>
                <td class="b0">
                  <p class="h4 mt-0">
                    <span class="align-middle text-bold link-unstyled">
                      {{ $t('tenderview.tender') }} {{ tender.tender_code }}
                    </span>
                    <span class="rounded badge bg-success-light px-4 ml-2 text-sm d-lg-inline" v-if="is_active">
                      <span class="text-white">{{ $t('tenders.state.active') }}</span>
                    </span>
                    <span class="rounded badge bg-warning-light px-4 ml-2 text-sm d-lg-inline" v-if="is_waiting">
                      <span class="text-white">{{ $t('tenders.state.waiting') }}</span>
                    </span>
                    <span class="rounded badge bg-warning-light px-4 ml-2 text-sm d-lg-inline" v-if="is_finished">
                      <span class="text-white">{{ $t('tenders.state.finished') }}</span>
                    </span>
                    <span class="rounded badge bg-warning-dark px-4 ml-2 text-sm d-lg-inline" v-if="is_choosing">
                      <span class="text-white">{{ $t('tenders.state.choosing') }}</span>
                    </span>
                    <span class="rounded badge bg-info-light px-4 ml-2 text-sm d-lg-inline" v-if="is_ordered">
                      <span class="text-white">{{ $t('tenders.state.ordered') }}</span>
                    </span>
                    <span class="rounded badge bg-danger-dark px-4 ml-2 text-sm d-lg-inline" v-if="is_canceled">
                      <span class="text-white">{{ $t('tenders.state.canceled') }}</span>
                    </span>
                    <span class="rounded badge bg-danger-light px-4 ml-2 text-sm d-lg-inline" v-if="is_failed">
                      <span class="text-white">{{ $t('tenders.state.failed') }}</span>
                    </span>
                  </p>

                  <div class="text-muted">
                    <span>{{ $t('tenderview.start') }}: {{ tender.start | formatDateTime }}</span><br>
                    <span>{{ $t('tenderview.end') }}: <b>{{ tender.finish | formatDateTime }} </b></span><br>
                    <span>{{ $t('tenderview.created') }}: <b>{{ tender.creator_name }} </b></span><br>
                    <span v-if="tender.group_name">{{ $t('tenderview.group') }}: <b>{{ tender.group_name }}</b></span>
                    <br v-if="tender.group_name">
                    <span v-if="tender.warehouse_name">{{ $t('tenderview.warehouse') }}: <b> {{ tender.warehouse_name }}</b></span>
                    <br v-if="tender.warehouse_name">
                    <span v-if="tender.approver_name != ''">{{ $t('tenderview.approver') }}: <b>{{ tender.approver_name}}</b></span>
                    <br v-if="tender.approver_name != ''">
                    <span v-if="tender.approved">{{ $t('tenderview.approved') }}: <b>{{ tender.approved | formatDateTime }}</b></span>
                  </div>
                  <h5 class="mt-2 mb-0" v-if="tender.additional_info">{{ $t('tenderview.additional-info') }}:</h5>
                  <div class="text-muted" v-if="tender.additional_info">
                    {{ tender.additional_info }}
                  </div>
                  <div class="text-muted" v-if="is_supplier">
                    <span v-if="tender.proposal_created">{{ $t('tenderview.proposal_created') }}:
                      <b>{{ tender.proposal_created | formatDateTime }}</b>
                    </span>
                  </div>
                  <div class="text-muted" v-if="is_supplier">
                    <span v-if="format_date_time(tender.proposal_created) !== format_date_time(tender.proposal_updated)">
                      {{ $t('tenderview.proposal_updated') }}: <b>{{ tender.proposal_updated | formatDateTime }}</b>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card card-default">
        <div class="card-body">
          <div class="table-responsive pb-5">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="wd-xs">#</th>
                  <th class="wd-sm" v-if="!is_supplier">{{ $t('tenderview.part-code') }}</th>
                  <th class="wd-xl">{{ $t('tenderview.name') }}</th>
                  <th class="wd-xs" v-if="!is_supplier">{{ $t('tenderview.transport-no') }}</th>
                  <th class="wd-sd">{{ $t('details.customer_name') }}</th>
                  <th class="wd-xs">{{ $t('tenderview.needed-qty') }}</th>
                  <th class="wd-sd" v-if="!is_supplier">{{ $t('tenderview.offer') }}</th>
                  <th class="wd-sd" v-if="is_supplier">{{ $t('tenderview.offer-reg-nr') }}</th>
                  <th class="wd-xs" v-if="!is_supplier">{{ $t('tenderview.price-wo-vat') }}</th>
                  <th class="wd-sd" v-if="!is_supplier">{{ $t('tenderview.producer') }}</th>
                  <th class="wd-sd" v-if="!is_supplier">{{ $t('tenderview.product-code') }}</th>
                  <th class="wd-xxl" v-if="!is_supplier">
                    {{ $t('tenderview.quantity') }} / {{ $t('tenderview.availability') }} | {{ $t('tenderview.ordered_qty') }} ({{ $t('tenderview.reason') }})
                  </th>
                  <th class="wd-xxl" v-if="is_supplier">
                    {{ $t('tenderview.price-wo-vat') }} ({{ $t('tenderview.reason') }})
                  </th>
                  <th class="wd-sd" v-if="!is_supplier">{{ $t('details.creator') }}</th>
                  <th class="wd-sd" v-if="!is_supplier">{{ $t('details.order_number') }}</th>
                  <th class="wd-xs" v-if="!is_supplier">BC</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="d.id" v-for="(d, index) in details">
                <td>{{ index+1 }}</td>
                <td v-if="!is_supplier">
                    {{ d.part_code }}
                </td>
                <td>{{ d.part_name }}
                  <button
                    class="btn btn-link pl-1 pt-1"
                    @click="open_modal(d.part_name, d.part_codes_tags)"
                    v-if="d.part_codes_tags">
                    <i class="fa icon-info ml-1"></i>
                  </button>
                </td>
                <td v-if="!is_supplier">{{ d.customer_number }}</td>
                <td>{{ d.customer_name }}</td>
                <td>{{ d.qty }}</td>

                <td>
                  <div :key="'supplier_' + index" v-for="(p, index) in number_of_lines(d.proposals, d.lines)">
                    <span v-if="!is_supplier">
                      <span v-if="p && winner(d, p)" class="text-bold text-green">
                        {{ p.supplier_name }}
                      </span>
                      <span v-else-if="p">
                        {{ p.supplier_name }}
                      </span>
                    </span>
                    <span v-if="is_supplier && d.takes_part">
                      <span v-if="p && winner(d, p)" class="text-bold text-green">
                        {{ p.supplier_name }} ({{ p.supplier_registration_code }})
                      </span>
                      <span v-else-if="p">
                        {{ p.supplier_name }} ({{ p.supplier_registration_code }})
                      </span>
                    </span>
                  </div>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines <= 3"
                    @click="show_more(d)">{{ $t('tenderview.more') }} ...
                  </button>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines > 3"
                    @click="show_less(d)">{{ $t('tenderview.less') }} ...
                  </button>
                </td>

                <td v-if="!is_supplier">
                  <div :key="'price_' + index" v-for="(p, index) in number_of_lines(d.proposals, d.lines)">
                    <span v-if="p && p.price > 0 && winner(d, p)" class="text-bold text-green">
                      {{ p.price.toFixed(4).replace(/0{0,2}$/, '') }} {{ $t('global.euro-sign') }}
                    </span>
                    <span v-else-if="p && p.price > 0">
                      {{ p.price.toFixed(4).replace(/0{0,2}$/, '') }} {{ $t('global.euro-sign') }}
                    </span>
                  </div>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines <= 3"
                    @click="show_more(d)">{{ $t('tenderview.more') }} ...
                  </button>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines > 3"
                    @click="show_less(d)">{{ $t('tenderview.less') }} ...
                  </button>
                </td>

                <td v-if="!is_supplier">
                  <div :key="'producer_' + index" v-for="(p, index) in number_of_lines(d.proposals, d.lines)">
                    <span v-if="p && winner(d, p)" class="text-bold text-green">{{ p.producer.name }}</span>
                    <span v-else-if="p">{{ p.producer.name }}</span>
                  </div>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines <= 3"
                    @click="show_more(d)">{{ $t('tenderview.more') }} ...
                  </button>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines > 3"
                    @click="show_less(d)">{{ $t('tenderview.less') }} ...
                  </button>
                </td>

                <td v-if="!is_supplier">
                  <div :key="'product_code_' + index" v-for="(p, index) in number_of_lines(d.proposals, d.lines)">
                    <span v-if="p && winner(d, p)" class="text-bold text-green">{{ p.product_code }}</span>
                    <span v-else-if="p">{{ p.product_code }}</span>
                  </div>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines <= 3"
                    @click="show_more(d)">{{ $t('tenderview.more') }} ...
                  </button>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines > 3"
                    @click="show_less(d)">{{ $t('tenderview.less') }} ...
                  </button>
                </td>

                <td v-if="!is_supplier">
                  <div :key="'qty_' + index" v-for="(p, index) in number_of_lines(d.proposals, d.lines)">
                    <div v-if="p && winner(d, p) ">
                      <span v-if="p.available_qty > 0" class="text-bold text-green">{{ p.available_qty }} {{ $t('tenderview.available') }} / </span>
                      <span class="text-bold text-green">{{ p.additional_qty }}</span>
                      <span v-if="p.delivery_date" class="text-bold text-green"> ({{ p.delivery_date | formatDate }})</span>
                      <span class="text-bold text-green"> | {{winner(d, p).amount}}</span>
                      <span class="text-bold text-green" v-if="reason_name(winner(d, p).reason)"> ({{reason_name(winner(d, p).reason)}})</span>
                    </div>
                    <div v-else-if="p">
                      <span v-if="p.available_qty > 0 && !is_supplier">{{ p.available_qty }} {{ $t('tenderview.available') }} / </span>
                      <span v-if="!is_supplier">{{ p.additional_qty }}</span>
                      <span v-if="p.delivery_date"> ({{ p.delivery_date | formatDate }})</span>
                    </div>
                  </div>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines <= 3"
                    @click="show_more(d)">{{ $t('tenderview.more') }} ...
                  </button>
                  <button
                    class="btn btn-link btn-sm pl-0"
                    v-if="d.proposals.length > 3 && d.lines > 3"
                    @click="show_less(d)">{{ $t('tenderview.less') }} ...
                  </button>
                </td>

                <td v-if="is_supplier">
                  <span v-if="d.takes_part">
                    <div :key="'price_' + index" v-for="(p, index) in number_of_lines(d.proposals, d.lines)">
                      <span v-if="p && p.price > 0 && winner(d, p)" class="text-bold text-green">
                        {{ p.price.toFixed(4).replace(/0{0,2}$/, '') }} {{ $t('global.euro-sign') }}
                        <span v-if="reason_name(winner(d, p).reason)"> ({{reason_name(winner(d, p).reason)}})</span>
                      </span>
                      <span v-else-if="p && p.price > 0">
                        {{ p.price.toFixed(4).replace(/0{0,2}$/, '') }} {{ $t('global.euro-sign') }}
                      </span>
                    </div>
                    <button
                      class="btn btn-link btn-sm pl-0"
                      v-if="d.proposals.length > 3 && d.lines <= 3"
                      @click="show_more(d)">{{ $t('tenderview.more') }} ...
                    </button>
                    <button
                      class="btn btn-link btn-sm pl-0"
                      v-if="d.proposals.length > 3 && d.lines > 3"
                      @click="show_less(d)">{{ $t('tenderview.less') }} ...
                    </button>
                  </span>
                </td>

                <td v-if="!is_supplier">{{ d.creator_name }}</td>
                <td v-if="!is_supplier">{{ d.order_number }}</td>
                <td v-if="!is_supplier">
                  <b-c-detail-status
                    v-if="d.bc_id"
                    justify-content="left"
                    :detail="d"
                  />
                </td>

                <td v-if="!is_supplier">
                  <div class="btn-group">
                    <button v-if="d.supplier_comments.length > 0 || d.winner_comment"
                      class="btn btn-link link-unstyled p-1"
                      :title="$t('tenderview.show-comments')"
                      @click="open_detail_comments_modal(d)"
                      data-toggle="modal"
                      data-target="#commentsModal">
                      <i class="icon-bubbles text-info"></i>
                      <span class="text-bold" v-if="d.supplier_comments.length > 0">({{d.supplier_comments.length}})</span>
                      <span class="text-success" v-if="d.winner_comment">(1)</span>
                    </button>
                  </div>
                </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="tender.comments_options && tender.comments_options.length > 0">
            <h4>{{ $t('tenderview.comment') }}</h4>
            <hr>
            <div
              class="comment"
              v-if="c && c.content"
              v-for="(c, index) in tender.comments_options"
              :key="'comment_' + index">
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="b0 pl-0">
                        <p class="h4 mt-0">
                          <span class="text-bold">{{ c.supplier_name }}</span>
                        </p>
                        <div class="text-muted">{{ c.content }}</div>
                        <div>{{ c.created | formatDateTime }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <hr/>
          <comment :tender="tender" v-if="tender.approver_comment && tender.approver_comment.content && !is_supplier" />
          <div>
            <button
                v-if="is_administrator"
                class="btn btn-outline-info fa-pull-right ml-2"
                @click="reopenTender">
              {{ $t('tenderview.reopen-tender') }}
            </button>

            <router-link
              :to="{name: 'tender_view', params: {id: tender.id}}"
              class="btn btn-outline-warning fa-pull-right ml-2">
              <i class="fas fa-arrow-left"></i> {{ $t('tenderview.back-to-order') }}
            </router-link>
          </div>

        </div>
      </div>
    </div>

    <modal v-if="showModal">
      <h4 class="modal-title" slot="header-text">{{ $t('modal.header.text') }}</h4>
      <div class="modal-body" slot="modal-body">
        <p class="text-bold">{{ $t('modal.section1.header') }}</p>
        <p>{{ modal_data_1 }}</p>
        <p class="text-bold">{{ $t('modal.section2.header') }}</p>
        <p>{{ modal_data_2}}</p>
      </div>
      <div slot="modal_buttons">
        <button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
      </div>
    </modal>

    <modal v-if="showModalDetailComments">
      <h4 class="modal-title" slot="header-text">{{ $t('detailcomments.comments-title') }}</h4>
      <div class="modal-body pre-scrollable" slot="modal-body">
        <div class="form-group">
          <label class="text-bold m-0">{{ $t('detailscomments.part-title') }}:</label>
          <p class="form-control-plaintext">
          <span
            v-if="!is_supplier">
            {{ row.part_code }}
          </span>
          {{ row.part_name }}
          </p>
          <h4 class="mt-2 text-bold"> {{ $t('detailcomments.comments-log') }}</h4>
        </div>
        <div
          class="form-group"
          v-for="(c, index) in row.supplier_comments"
          :key="'comment_' + index">
          <hr>
          <p class="form-control-plaintext">
             <span class="text-bold">{{c.name}}({{c.supplier}})</span>
             <span class="text-muted">{{c.created | formatDateTime}} </span>
          </p>
          <p class="form-control-plaintext">{{c.content}}</p>
        </div>
        <div class="form-group" v-if="row.winner_comment">
          <hr>
          <p class="form-control-plaintext">
            <span class="text-bold text-info">{{row.winner_comment_data.name}}</span>
            <span class="text-muted">{{row.winner_comment_data.created | formatDateTime}} </span>
          </p>
          <p class="form-control-plaintext">{{row.winner_comment_data.content}}</p>
        </div>
      </div>
      <div slot="modal_buttons">
        <button
          class="btn btn-secondary"
          type="button"
          @click="close_detail_comments_modal()">{{ $t('modal.close') }}
        </button>
      </div>
    </modal>
  </section>
</template>

<script>
import api from '@/api'
import Modal from '@/components/Modal.vue'
import Comment from '@/components/Comment.vue'
import moment from 'moment'
import message from '@/message'
import BCDetailStatus from "@/components/BCDetailStatus.vue";
import BCTenderStatus from "@/components/BCTenderStatus.vue";

const getData = (id, route, next) => {
  Promise.all([
    api.get(`/tenders/${id}/`),
    api.get(`/details/?tender=${id}&page_size=1000&mode=history`)
  ])
    .then(([tender, details]) => {
      let data = details.data.results

      if (tender.data.approver_comment === null) {
        tender.data.approver_comment = {
          content: ''
        }
      } else {
        tender.data.approver_comment = {
          id: tender.data.approver_comment,
          content: tender.data.approver_comment_content
        }
      }

      data.forEach(d => {
        d.errors = {}
        d.lines = 3

        if (d.proposals.length && d.proposals_options.length) {
          d.proposals = d.proposals_options
        } else {
          d.proposals = [{
            producer: {
              id: null,
              name: ''
            }
          }]
        }
      })
      next({
        tender: tender.data,
        details: data
      })
    })
}

export default {
  components: {
    BCTenderStatus,
    BCDetailStatus,
    modal: Modal,
    comment: Comment
  },
  data () {
    return {
      tender: {},
      details: [],
      showModal: false,
      modal_data_1: null,
      modal_data_2: null,
      showModalDetailComments: false
    }
  },
  mounted () {
    this.$parent.menu = 'tenders'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  computed: {
    is_active () {
      return this.tender.status === 'ACTIVE'
    },
    is_choosing () {
      return this.tender.status === 'CHOOSING'
    },
    is_waiting () {
      return this.tender.status === 'WAITING'
    },
    is_finished () {
      return this.tender.status === 'FINISHED'
    },
    is_ordered () {
      return this.tender.status === 'ORDERED'
    },
    is_canceled () {
      return this.tender.status === 'CANCELED'
    },
    is_failed () {
      return this.tender.status === 'FAILED'
    },
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    is_administrator() {
      return this.$store.getters.user_group === 'Administrator'
    },
  },
  methods: {
    reopenTender() {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('tenderview.reopen-tender-question'),
        showCancelButton: true
      })
          .then((choice) => {
            if (choice.value) {
              api.post(`/tenders/${this.tender.id}/reopen/`)
                  .then(() => {
                    message.success(this.$i18n.t('tenderview.reopen-tender-success'))
                    this.$router.push({name: 'tender_view', params: {id: this.tender.id}})
                  })
                  .catch(() => {
                    message.error(this.$i18n.t('tenderview.reopen-tender-fail'))
                  })
            }
          })
    },
    format_date_time(dt) {
      return moment(String(dt)).format('DD.MM.YYYY HH:mm')
    },
    close_modal () {
      if (this.showModal) {
        this.showModal = false
      } else if (this.showModalDetailComments) {
        this.showModalDetailComments = false
      }
    },
    open_modal (data1, data2) {
      this.showModal = true
      this.modal_data_1 = data1
      this.modal_data_2 = data2
    },
    open_detail_comments_modal (detail) {
      this.row = detail
      this.showModalDetailComments = true
    },
    close_detail_comments_modal () {
      this.showModalDetailComments = false
    },
    show_more (d) {
      d.lines = d.proposals.length
    },
    show_less (d) {
      d.lines = 3
    },
    number_of_lines (data, num) {
      let lines = []
      for (let i = 0; i < num; i++) {
        lines.push(data[i])
      }
      return lines
    },
    winner (d, p) {
      return d.winners.find(winner => winner.name === p.id)
    },
    reason_name (status) {
      switch (status) {
        case 'PRICE': return this.$i18n.t('tenderview.reason-price')
        case 'DUE DATE': return this.$i18n.t('tenderview.reason-due-date')
        case 'PRODUCER': return this.$i18n.t('tenderview.reason-producer')
        case 'TEST': return this.$i18n.t('tenderview.reason-test')
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/TenderHistory.vue